import React from 'react';
import type { DlPanel } from '../../../../../components/immobilien/dienstleisterWidgets';
import { AnsprechpartnerPanel, BankPanel, KonditionenPanel, StammdatenPanel } from './StammPanels';
import { GewerkePanel, ObjektePanel } from './LeistungPanels';
import { AuftraegePanel, BewertungPanel, RechnungenPanel, RegelnPanel } from './AuftragPanels';
import { DokumentePanel, KiPanel, KommunikationPanel, NachweisePanel, NotizenPanel, PortalPanel, TerminePanel, VertraegePanel } from './VertragPanels';

/** Inhalt der Dienstleister-Panels (Handoff Dienstleister §9). */
export function DienstleisterPanelInhalt({ panel }: { panel: DlPanel }) {
  switch (panel) {
    case 'kontakt': return <StammdatenPanel />;
    case 'ansprech': return <AnsprechpartnerPanel />;
    case 'konditionen': return <KonditionenPanel />;
    case 'bank': return <BankPanel />;
    case 'objekte': return <ObjektePanel />;
    case 'kategorien': return <GewerkePanel />;
    case 'tickets': return <AuftraegePanel />;
    case 'rechnungen': return <RechnungenPanel />;
    case 'regeln': return <RegelnPanel />;
    case 'profil':
    case 'bewertung': return <BewertungPanel />;
    case 'vertraege': return <VertraegePanel />;
    case 'nachweise': return <NachweisePanel />;
    case 'portal': return <PortalPanel />;
    case 'termine': return <TerminePanel />;
    case 'aktivitaet': return <KommunikationPanel />;
    case 'dokumente': return <DokumentePanel />;
    case 'notizen': return <NotizenPanel />;
    case 'ki': return <KiPanel />;
  }
}
